module.exports = "https://bin.bnbstatic.com/_next/static/images/community-01b53e661540d8701e3ca93d1572469c.jpg";